
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.025 3.11c0-.447.222-.84.56-1.082a2.193 2.193 0 00-1.005-.25 2.224 2.224 0 00-2.22 2.22c0 1.225.996 2.222 2.22 2.222a2.22 2.22 0 002.184-1.847 1.325 1.325 0 01-1.74-1.263z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M15.05 3.702C14.914 3.55 11.659 0 7.58 0 3.504 0 .25 3.55.113 3.702a.444.444 0 000 .592c.136.151 3.391 3.702 7.468 3.702 4.078 0 7.333-3.55 7.469-3.702a.444.444 0 000-.592zM7.58 7.108a3.113 3.113 0 01-3.11-3.11 3.113 3.113 0 013.11-3.11 3.113 3.113 0 013.11 3.11 3.113 3.113 0 01-3.11 3.11zM13.356 10.58l-1.547-.984-3.413 2.172a1.502 1.502 0 01-1.609 0L3.373 9.596l-1.548.985a.5.5 0 000 .843l5.497 3.498a.5.5 0 00.537 0l5.497-3.498a.5.5 0 000-.843z","fill":"#E2E8F0"}})])
          )
        }
      }
    